"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Justification = _interopRequireDefault(require("./Justification"));

var _ITSM = _interopRequireDefault(require("./ITSM"));

var _constants = require("./constants");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.advanced-settings-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .advanced-settings-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .advanced-settings-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .advanced-settings-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .advanced-settings-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n\n.margin-top-32 {\n  margin-top: 2rem; }\n\n.margin-top-8 {\n  margin-top: 0.5rem; }\n\n.reset-button {\n  cursor: pointer;\n  color: #067fdb;\n  font-size: 1rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n\n.info-icon {\n  display: flex;\n  align-items: center;\n  gap: 0.3125rem; }\n  .info-icon img {\n    height: 1.125rem; }\n";
  var fileName = "compone_Settings";
  var element = document.querySelector("style[data-sass-component='compone_Settings']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var AdvancedSettings = function AdvancedSettings(_ref) {
  var _ref$handleJustificat = _ref.handleJustificationChange,
      handleJustificationChange = _ref$handleJustificat === void 0 ? function () {} : _ref$handleJustificat,
      _ref$handleResetJusti = _ref.handleResetJustification,
      handleResetJustification = _ref$handleResetJusti === void 0 ? function () {} : _ref$handleResetJusti,
      _ref$handleITSMChange = _ref.handleITSMChange,
      handleITSMChange = _ref$handleITSMChange === void 0 ? function () {} : _ref$handleITSMChange,
      _ref$handleResetITSM = _ref.handleResetITSM,
      handleResetITSM = _ref$handleResetITSM === void 0 ? function () {} : _ref$handleResetITSM,
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? [] : _ref$settings,
      _ref$showToast = _ref.showToast,
      showToast = _ref$showToast === void 0 ? function () {} : _ref$showToast;
  var JustificationResponse = settings === null || settings === void 0 ? void 0 : settings.find(function (key) {
    return (key === null || key === void 0 ? void 0 : key.settingsType) === 'JUSTIFICATION';
  });
  var ITSMResponse = settings === null || settings === void 0 ? void 0 : settings.find(function (key) {
    return (key === null || key === void 0 ? void 0 : key.settingsType) === 'ITSM';
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.mainContainer
  }, /*#__PURE__*/_react.default.createElement(_Justification.default, {
    showToast: showToast,
    handleJustificationChange: handleJustificationChange,
    handleResetJustification: handleResetJustification,
    settingsResp: JustificationResponse,
    displayReset: !(0, _lodash.isEmpty)(JustificationResponse)
  }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_ITSM.default, {
    showToast: showToast,
    handleITSMChange: handleITSMChange,
    handleResetITSM: handleResetITSM,
    settingsResp: ITSMResponse,
    displayReset: !(0, _lodash.isEmpty)(ITSMResponse)
  }), /*#__PURE__*/_react.default.createElement("hr", null));
};

AdvancedSettings.propTypes = {
  settings: _propTypes.default.array,
  handleJustificationChange: _propTypes.default.func.isRequired,
  handleResetJustification: _propTypes.default.func.isRequired,
  handleITSMChange: _propTypes.default.func.isRequired,
  handleResetITSM: _propTypes.default.func.isRequired,
  showToast: _propTypes.default.func
};
var _default = AdvancedSettings;
exports.default = _default;